<template>
    <div class="distributor-authentication">
      <div class="common-header-wrap">
        <mt-header :title="$t('distributor.title.register_info')" class="common-header">
          <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
          <mt-button slot="right" @click="$router.push({ name: 'DistributorHome' })" >{{ $t('general.save') }}</mt-button>
        </mt-header>
      </div>
      <div class="user-avatar" ref="upload_btn" @change="uploadAvatar($event,'identify')">
        <img v-if="user.identify_image" :src="user.identify_image">
        <div class="notice">
          <p class="iconfont">&#xe639;</p>
          <p>{{ $t('distributor.account.upload_id_front') }}</p>
        </div>
        <input type="file" accept="image/jpg,image/png,image/gif,image/bmp,image/jpeg">
      </div>

      <div class="user-avatar" ref="upload_bt2" @change="uploadAvatar($event,'identify_back')">
        <img v-if="user.identify_image_back" :src="user.identify_image_back">
        <div class="notice">
          <p class="iconfont">&#xe639;</p>
          <p>{{ $t('distributor.account.upload_id_back') }}</p>
        </div>
        <input type="file" accept="image/jpg,image/png,image/gif,image/bmp,image/jpeg">
      </div>

      <div class="user-avatar" ref="upload_btn3" @change="uploadAvatar($event,'deposit')">
        <img v-if="user.deposit_image" :src="user.deposit_image">
        <div class="notice">
          <p class="iconfont">&#xe639;</p>
          <p>{{ $t('distributor.account.upload_bank')}}</p>
        </div>
        <input type="file" accept="image/jpg,image/png,image/gif,image/bmp,image/jpeg">
      </div>

    </div>
</template>

<script>

import { Toast } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { uploadUserFile } from '../../../api/distributorUser'
export default {
  components: {
  },
  name: 'DistributorAuthentication',
  data () {
    return {
    }
  },
  mounted () {

  },
  computed: {
    ...mapState({
      user: state => state.distributor.info
    })
  },
  created: function () {

  },

  methods: {
    ...mapMutations({
      distributorEdit: 'distributorEdit'
    }),
    uploadAvatar (event, type) {
      if (typeof (event.target.files[0]) === 'undefined') {
        return
      }
      let formdata = new FormData()

      formdata.append('file', event.target.files[0])
      formdata.append('type', type)
      uploadUserFile(formdata).then(res => {
        if (type == 'identify') {
          this.user.identify_image = res.result.url
          this.distributorEdit({ identify_image: res.result.url })
        } else if (type == 'identify_back') {
          this.user.identify_image_back = res.result.url
          this.distributorEdit({ identify_image_back: res.result.url })
        } else {
          this.user.deposit_image = res.result.url
          this.distributorEdit({ deposit_image: res.result.url })
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
  .distributor-authentication {
    .user-avatar {
      border:1px solid #aaa;
      position: relative;
      width: 12rem;
      height: 7rem;
      margin: 2rem auto;
      text-align: center;
      .notice{position:absolute;top:30%;font-size:.8rem;width:100%;
        .iconfont{font-size:1.5rem}
      }
      img {
        border:0;
        width: 100%;
        height: 100%
      }
      input {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0
      }
    }

  }

</style>
